module.exports = __webpack_public_path__ + "static/3-0731e2bdfcdacb24b0490590176ec609.jpg";